module.exports = __webpack_public_path__ + "static/img/about-04.36b9388.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-04.png
// module id = ZHzS
// module chunks = 0